import { useMutation, useQueryClient } from '@tanstack/react-query';
import { createWorkStatus, CreateWorkStatusPayload, CreateWorkStatusResponse } from '../api/createWorkStatus';
import { WorkStatus } from 'types/project/projectDefaults';

export const useUpdateWorkStatusOrderMutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (payload: CreateWorkStatusPayload & { workStatusUuid: string; statusOrder: number }) => 
      createWorkStatus(payload),
    
    onMutate: async (updatedColumn) => {
      // Cancel any outgoing refetches so they don't overwrite our optimistic update
      await queryClient.cancelQueries({ queryKey: ['project-default', updatedColumn.projectUuid] });
      return { projectUuid: updatedColumn.projectUuid };
    },
    onSettled: (data, error, variables) => {
      queryClient.invalidateQueries({ queryKey: ['project-default', variables.projectUuid] });
    },
    onError: (err, newStatus) => {
      console.error(`Reorder mutation failed for status ${newStatus.workStatusUuid}:`, err);
    },
  });
};
